import React from 'react';

// ─── MODAL ────────────────────────────────────────────────────────────────────
// Overlay dialog — centered card on desktop, bottom sheet on phones (CSS).
// Tap the backdrop or the ✕ to close.

export default function Modal({ title, onClose, children, footer }) {
  return (
    <div className="ui-modal-overlay" onClick={onClose}>
      <div className="ui-modal" role="dialog" aria-label={title} onClick={e => e.stopPropagation()}>
        <div className="ui-modal__header">
          <span className="ui-modal__title">{title}</span>
          <button type="button" className="ui-modal__close" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className="ui-modal__body">{children}</div>
        {footer && <div className="ui-modal__footer">{footer}</div>}
      </div>
    </div>
  );
}
